module.exports = __webpack_public_path__ + "static/media/distance.fd726130.svg";